/*
 * HomePage
 */

import React from 'react';

// Material Resources

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../NotFoundPage';
import EditMenu from '../../components/EditMenu';

function EditMenuPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={EditMenu} />
      <Route path="" component={NotFound} />
    </Switch>
  );
}

export default EditMenuPage;
